const highlights = [
  {
    icon: 'ri-heart-pulse-line',
    color: '#FF8C69',
    label: '三大專長',
    title: '醫療保障｜家庭風險｜資產防護',
    desc: '深耕三大核心領域，協助您從個人到家庭、從當下到未來，建立完整的保障體系。',
  },
  {
    icon: 'ri-route-line',
    color: '#5C5470',
    label: '服務方法',
    title: '傾聽 → 診斷 → 設計 → 追蹤',
    desc: '四步驟結構化流程，確保每一份規劃都有紮實的需求基礎，而非憑感覺推薦。',
  },
  {
    icon: 'ri-shield-check-line',
    color: '#D4A373',
    label: '服務承諾',
    title: '只推「需要」的，不賣「最多」的',
    desc: '以客戶真實需求為優先，拒絕過度銷售，讓每一分保費都花在真正有意義的地方。',
  },
];

export default function AboutIntro() {
  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-16 items-start">
          {/* Left: Text */}
          <div className="w-full lg:w-[48%]">
            <p className="text-[#D4A373] font-semibold tracking-widest mb-4" style={{ fontSize: '1rem' }}>
              ABOUT ME
            </p>
            <h2
              className="font-serif font-bold text-[#5C5470] mb-6"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
            >
              我是保險建築師
              <br />
              <span className="text-[#D4A373]">琮恩</span>
            </h2>
            <div className="w-14 h-1 bg-[#D4A373] rounded-full mb-8"></div>

            <p
              className="text-gray-700 mb-6"
              style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}
            >
              從業超過 10 年，專注醫療保險、家庭保障、資產與風險管理與退休規劃整合。
            </p>
            <p
              className="text-gray-700 mb-8"
              style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}
            >
              我的工作不只是建議保單，而是替您設計一座能住一輩子的安心保險堡壘。每一次諮詢，我都從傾聽開始——因為唯有真正理解您的生活與擔憂，才能設計出真正適合您的保障結構。
            </p>

            {/* Stats row */}
            <div className="flex flex-wrap gap-6">
              {[
                { num: '10+', label: '年從業經驗' },
                { num: '500+', label: '服務客戶' },
                { num: '98%', label: '客戶滿意度' },
              ].map((s) => (
                <div key={s.label} className="text-center">
                  <div
                    className="font-serif font-bold text-[#5C5470]"
                    style={{ fontSize: '2.125rem', lineHeight: '1.2' }}
                  >
                    {s.num}
                  </div>
                  <div className="text-gray-500 mt-1" style={{ fontSize: '1rem' }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: 3 Highlight Cards */}
          <div className="w-full lg:w-[52%] flex flex-col gap-5">
            {highlights.map((h) => (
              <div
                key={h.label}
                className="flex items-start gap-5 bg-[#F8F5F0] rounded-2xl p-6 border border-transparent hover:border-[#D4A373]/30 transition-all duration-200"
              >
                <div
                  className="w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0"
                  style={{ backgroundColor: `${h.color}18` }}
                >
                  <i className={`${h.icon} text-2xl`} style={{ color: h.color }}></i>
                </div>
                <div>
                  <span
                    className="inline-block px-3 py-0.5 rounded-full font-medium mb-2"
                    style={{ fontSize: '1rem', backgroundColor: `${h.color}18`, color: h.color }}
                  >
                    {h.label}
                  </span>
                  <h3
                    className="font-serif font-bold text-[#5C5470] mb-2"
                    style={{ fontSize: 'clamp(1.125rem, 1.5vw, 1.375rem)', lineHeight: '1.5' }}
                  >
                    {h.title}
                  </h3>
                  <p className="text-gray-600" style={{ fontSize: '1.0625rem', lineHeight: '1.7' }}>
                    {h.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
